module.exports = __webpack_public_path__ + "officialStatic/img/product-qlbj.c5af891.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/product-qlbj.png
// module id = Np0L
// module chunks = 0